import React, { useEffect, useState } from "react";
import apiRequest from "../../../../utils/ApiRequest/apiRequest.js";
import GetTransformedDate from "../../../../utils/dateViewTransformer.tsx";
import useMediaQueries from "../../../../hooks/useMediaQueries.js";
import Icon from "../../../Elements/Icon/Icon.tsx";
import LoadingImageElement from "components/Elements/LoadingContainerElement/LoadingImageElement.tsx";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";

const SingleDataRecord = ({ data, apiView, setShowJson }) => {
  const { getTextByKey } = useContent();
  const { desktopCondition } = useMediaQueries();
  const [showAll, setShowAll] = useState(desktopCondition);

  const prefix = apiView ? "API" : "FTP";

  return (
    <div className="single-item">
      <div className="delivery-number-part">
        <p>{getTextByKey("embed-delivery-number")}</p>
        <span>{data[prefix + "MailId"]}</span>
      </div>
      <div className="date-part">
        <p>{getTextByKey("date-time-actions-log")}</p>
        <span>
          <GetTransformedDate
            date={data[prefix + "CreationDateTime"]}
            showTime={true}
          />
        </span>
      </div>
      {showAll ? (
        <>
          <div className="form-id-part">
            <p>{getTextByKey("form-id-actions-log")}</p>
            <span>{data[prefix + "EmbedFormId"]}</span>
          </div>
          <div className="status-part">
            <p>{getTextByKey("status-actions-log")}</p>
            <span>{data[prefix + "Status"] === 0 ? "OK" : "ERROR"}</span>
          </div>
          <div className="error-desc">
            <p>{getTextByKey("error-desc-actions-log")}</p>
            <span>{data[prefix + "ErrorDescription"]}</span>
          </div>
          {apiView ? (
            <div className="json-view-part">
              <p>JSON</p>
              <span
                onClick={() => {
                  setShowJson(JSON.parse(data.ApiJson));
                }}
              >{`{ JSON }`}</span>
            </div>
          ) : null}
        </>
      ) : null}
      {!desktopCondition ? (
        <div
          className={`show-all-info${showAll ? " open" : ""}`}
          onClick={() => setShowAll((prev) => !prev)}
        >
          <Icon name="arrow-down" gray />
        </div>
      ) : null}
    </div>
  );
};

const DataRecordElem = ({ data, index, apiView, setShowJson }) => {
  const isDivisible = index % 2 === 0;
  const classNames = `action-item${!isDivisible ? "" : " gray-background"}`;

  const prefix = apiView ? "API" : "FTP";

  return (
    <div className={classNames}>
      <div className="date-part">
        <GetTransformedDate
          date={data[prefix + "CreationDateTime"]}
          showTime={true}
        />
      </div>
      <div className="form-id-part">{data[prefix + "EmbedFormId"]}</div>
      <div className="delivery-number-part">{data[prefix + "MailId"]}</div>
      <div className="status-part">
        {data[prefix + "Status"] === 0 ? "OK" : "ERROR"}
      </div>
      <div className="error-desc">{data[prefix + "ErrorDescription"]}</div>
      {apiView ? (
        <div
          className="json-view-part"
          onClick={() => {
            setShowJson(JSON.parse(data.ApiJson));
          }}
        >{`{ JSON }`}</div>
      ) : null}
    </div>
  );
};

export const LogModal = ({ deliveryNumber, ftpDefault }) => {
  const { getTextByKey } = useContent();
  const { desktopCondition } = useMediaQueries();

  const [fetchedData, setFetchedData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [apiView, setApiView] = useState(!ftpDefault);
  const [showJson, setShowJson] = useState();

  const handleFetch = async () => {
    setLoading(true);
    const response = await apiRequest("Mails", "ReactGetFormsLog", {
      mailId: deliveryNumber,
    });
    if (response.status === "success") {
      setFetchedData(response.data);
    }
    setLoading(false);
  };

  useEffect(() => {
    handleFetch();
  }, []);

  const dataToShow = !fetchedData
    ? []
    : apiView
    ? fetchedData.APILogs
    : fetchedData.FTPLogs;

  return (
    <div className="log-modal-wrapper">
      {loading ? (
        <LoadingImageElement />
      ) : (
        <>
          {showJson ? (
            <>
              <div className="json-title">
                <div className="back-item" onClick={() => setShowJson(null)}>
                  <Icon name="arrow-back" gray />
                </div>
                <span>
                  {getTextByKey("json-title")}: {deliveryNumber}
                </span>
                <div className="flex-spacer" />
                {/* <div className="copy-button">
                  <Tooltip
                    id={"copyLinkIcon"}
                    tooltipTextKey="copy-icon-tooltip-text"
                    top
                  >
                    <Icon
                      name="copy"
                      blue
                      onClick={() => handleCopy(showJson)}
                    />
                  </Tooltip>
                </div> */}
              </div>
              <div className="json-data">
                {JSON.stringify(showJson, null, " \n")}
              </div>
            </>
          ) : (
            <>
              <div className="log-title">
                {getTextByKey("actions-log-title")}
              </div>
              <div className="tab-section">
                <div
                  className={`api-button${apiView ? " selected" : ""}`}
                  onClick={() => setApiView(true)}
                >
                  {getTextByKey("api-log-text")}
                </div>
                <div className="vertical-divider" />
                <div
                  className={`ftp-button${!apiView ? " selected" : ""}`}
                  onClick={() => setApiView(false)}
                >
                  {getTextByKey("ftp-log-text")}
                </div>
              </div>
              <div className="data-container">
                {dataToShow.length === 0 ? (
                  <div className="empty-log-message">
                    {getTextByKey(`no-${apiView ? "api" : "ftp"}-records`)}
                  </div>
                ) : dataToShow.length === 1 ? (
                  <SingleDataRecord
                    apiView={apiView}
                    data={dataToShow[0]}
                    setShowJson={setShowJson}
                  />
                ) : (
                  <>
                    <div className="data-headers">
                      <div className="date-part">
                        {getTextByKey("date-time-actions-log")}
                      </div>
                      <div className="form-id-part">
                        {getTextByKey("form-id-actions-log")}
                      </div>
                      <div className="delivery-number-part">
                        {getTextByKey("embed-delivery-number")}
                      </div>
                      <div className="status-part">
                        {getTextByKey("status-actions-log")}
                      </div>
                      <div className="error-desc">
                        {getTextByKey("error-desc-actions-log")}
                      </div>
                      {apiView ? (
                        <div className="json-view-part">JSON</div>
                      ) : null}
                    </div>
                    {dataToShow.map((item, i) => {
                      return desktopCondition ? (
                        <DataRecordElem
                          key={item.APILogId}
                          index={i}
                          data={item}
                          apiView={apiView}
                          setShowJson={setShowJson}
                        />
                      ) : (
                        <SingleDataRecord
                          apiView={apiView}
                          data={item}
                          setShowJson={setShowJson}
                          key={item.APILogId}
                        />
                      );
                    })}
                  </>
                )}
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};
